module.exports = __webpack_public_path__ + "static/images/fa-brands-400.5229663.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-brands-400.svg
// module id = 3nql
// module chunks = 13 14